module.exports = __webpack_public_path__ + "img/search.5ac51bf6.svg";